export default "__VITE_ASSET__BnYQEr0k__"